import moment from "moment";
import {isString} from "@/app/utils/StringUtils";

export default function(time, format) {
    if (!isString(format)) {
        format = "MMMM Do YYYY, HH:mm:ss";
    }
    return moment(time).utc().format(format);
}